import { installLocaleShortcut } from '../libs/localeShortcut';

export default {
  $oninit() {
    installLocaleShortcut();
  },
};
